<template>
    <div>
      <v-bottom-navigation
        :input-value="active"
        color="primary"
        app fixed
      >
      <v-btn
      v-for="(item, index) in filteredNavigations"
      :key="index"
      @click="onNavigationClick(item)"
       color="transparent"
    >
      <span>{{ item.name }}</span>
      <v-icon>{{ item.icon }}</v-icon>
    </v-btn>

        <!-- <v-btn @click="navigateTo('/')" color="transparent">
          <span>Home</span>
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn @click="navigateTo('/about')"  color="transparent">
          <span>About</span>
          <v-icon>mdi-information</v-icon>
        </v-btn>
        <v-btn @click="navigateTo('/metrics')"  color="transparent">
          <span>Metrics</span>
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
        <v-btn @click="showHelpSupportDialog = true" color="transparent">
          <span>Metrics</span>
          <v-icon >mdi-help-circle</v-icon>
        </v-btn> -->
      </v-bottom-navigation>

    </div>
  </template>
<script>
export default {
  name: 'BottomNavigation',
  data () {
    return {
      active: true,
      navigations: [
        { name: 'Home', icon: 'mdi-home', type: 'link', link: '/' },
        { name: 'About', icon: 'mdi-information', type: 'link', link: '/about' },
        { name: 'Migrations', link: '/migrations', icon: 'mdi-transfer', type: 'link' },
        { name: 'Metrics', icon: 'mdi-chart-bar', type: 'link', link: '/metrics' },
        { name: 'Help', icon: 'mdi-help-circle', type: 'button', link: '' }
      ]
    }
  },
  // add a method to navigate to the selected page using router
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    onNavigationClick (item) {
      if (item.type === 'link') {
        this.navigateTo(item.link)
      } else {
        if (item.name === 'Help') {
          this.$emit('toggle-help-dialog')
        }
      }
    }
  },

  computed: {
    filteredNavigations () {
      return this.navigations.filter(item => {
        if (item.name === 'Metrics') {
          return this.$userInfo.profile && this.$userInfo.profile.isAdmin
        }
        return true
      })
    }
  }
}
</script>
